import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const animalFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ANIMAL_CATEGORY,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Mammal",
          tagId: 4401,
        },
        {
          id: 2,
          label: "Bird",
          tagId: 4402,
        },
        {
          id: 3,
          label: "Reptile",
          tagId: 4403,
        },
        {
          id: 4,
          label: "Amphibian",
          tagId: 4404,
        },
        {
          id: 5,
          label: "Fish",
          tagId: 4405,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ANIMAL_HABITAT,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Habitat",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Earth",
          tagId: 4501,
        },
        {
          id: 2,
          label: "Water",
          tagId: 4502,
        },
        {
          id: 3,
          label: "Air",
          tagId: 4503,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_ANIMAL_LOCATION,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Locations",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "0-5",
          value: { minValue: 0, maxValue: 5 },
        },
        {
          id: 2,
          label: "6-20",
          value: { minValue: 6, maxValue: 20 },
        },
        {
          id: 3,
          label: "21-50",
          value: { minValue: 21, maxValue: 50 },
        },
        {
          id: 4,
          label: "51-100",
          value: { minValue: 51, maxValue: 100 },
        },
        {
          id: 5,
          label: "+100",
          value: { minValue: 100 },
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
